import React from "react";
import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";
import QuestionTemplate from "../../components/Questions/QuestionTemplate";

class QuestionContainer extends React.Component {
  render() {
    const { loading, error, provincial } = this.props;
    if (loading) return null;
    if (error) return null;
    return <QuestionTemplate question={provincial?.question} {...this.props} />;
  }
}

const QUESTION_QUERY = gql`
  query getQuestion($site: String!, $slug: String!) {
    provincial(site: $site) {
      question(slug: $slug) {
        id
        slug
        seo
        acf
        excerpt {
          rendered
        }
        title {
          rendered
        }
        content {
          rendered
        }
        featured_media {
          id
          source_url
          title {
            rendered
          }
          media_details {
            sizes {
              medium_large {
                source_url
              }
            }
          }
        }
      }
    }
  }
`;

const withQuestion = graphql(QUESTION_QUERY, {
  options: (props) => {
    let url;
    if (process.browser) {
      url = window.location.host;
    } else {
      url = props.url;
    }

    return {
      variables: {
        slug: props.match.params.slug,
        site: url,
      },
    };
  },
  props: ({ data }) => ({ ...data }),
});

export default withQuestion(QuestionContainer);
